// extracted by mini-css-extract-plugin
export default {"settings":"Ts8u2NF15DGN_HHQvPtc","photoBgButton":"rPS8XVgO96vuj4Ws_pzU"};